export default __webpack_public_path__ + "static/media/ceo-avatar.da1dd514.png";